import script from "./CreditRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditRequests.vue?vue&type=script&setup=true&lang=js"

import "./CreditRequests.vue?vue&type=style&index=0&id=43944d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43944d56"]])

export default __exports__